import { render, staticRenderFns } from "./CollectionsTopNav.vue?vue&type=template&id=2000ea60&scoped=true"
import script from "./CollectionsTopNav.vue?vue&type=script&lang=js"
export * from "./CollectionsTopNav.vue?vue&type=script&lang=js"
import style0 from "./CollectionsTopNav.vue?vue&type=style&index=0&id=2000ea60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2000ea60",
  null
  
)

export default component.exports